import React from 'react';
import embryoImage from "./logo/embryo.png";
import footerImage from "./logo/footer.png";
import embryoTitle from "./logo/3Dembryo.png";
import "./About.css";

const About = () => {
    return (
        <div className="about-container">
            <div className="about-logo">
                <img src={embryoTitle} alt="3Dembryo"/>
            </div>

            <div className="about-content">
                <h2>About Us</h2>
                <p>
                    Welcome to 3Dembryo!
                </p>
                <p>
                    Our website hosts interactive models, educational resources, and up-to-date research findings to support learning and scientific inquiry.
                </p>
                <p>
                    For further information, please contact us through these channels.
                </p>
            </div>

            <footer className="about-footer">
                <img src={footerImage} alt="footer" className="footer-image" />
                <div className="footer-text">
                    <p>This website is maintained by <a href="#">Jill Hikspoors</a>, 3Dembryo group, Maastricht University.</p>
                    <p>All site content, unless otherwise specified, is licensed under a <a href="#">Creative Commons Attribution License</a>. <a href="#">Please refer to the terms of use.</a></p>
                </div>
            </footer>
        </div>
    );
};

export default About;
